import { render, staticRenderFns } from "./SimpleOfferForm.vue?vue&type=template&id=24f251cb"
import script from "./SimpleOfferForm.vue?vue&type=script&lang=js"
export * from "./SimpleOfferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports